import cn from 'classnames';

import type {AutoDeliveryBase} from '@/types/icc/autoDeliveryDetails';
import stringUtils from '@/utils/stringUtils';

interface AutoDeliveryDcxDeliveryWindowLabelProps {
    className?: string;
    label?: string;
    minDeliveryDaysCount: AutoDeliveryBase['minDeliveryDaysCount'];
    maxDeliveryDaysCount: AutoDeliveryBase['maxDeliveryDaysCount'];
}

const AutoDeliveryDcxDeliveryWindowLabel = ({
    className,
    label,
    minDeliveryDaysCount,
    maxDeliveryDaysCount,
}: AutoDeliveryDcxDeliveryWindowLabelProps) => {
    if (!label) return null;

    const text = stringUtils.formatString(label, minDeliveryDaysCount, maxDeliveryDaysCount);

    return <div className={cn('text-12 leading-[16px] tracking-0 text-primary-dark', className)}>{text}</div>;
};

export default AutoDeliveryDcxDeliveryWindowLabel;
